import React from "react";
import TodayOpeningSlot from "./TodayOpeningSlot";

const OperatorSidebar = ({ operator }) => {
  return (
    <div className="w-full lg:w-[400px] flex flex-col items-center text-left text-text">
      <img
        src={operator.coverPhoto}
        alt={operator.name}
        className="rounded-xl w-full h-auto object-cover mb-4"
      />
      <h4 className="text-sm uppercase text-neutral-400 tracking-wide">
        {operator.town}
      </h4>
      <h2 className="text-2xl font-semibold text-redlight mb-2">
        {operator.name}
      </h2>
      <p className="text-sm mb-1">💈 {operator.address}</p>

      {/* Status (open/close today) */}
      <TodayOpeningSlot operator={operator} />

      <p className="text-sm mb-1">📞 {operator.phone}</p>
      <p className="text-sm mb-4">📩 {operator.email}</p>

      <div className="w-full bg-dry p-4 rounded-md mb-4 hidden lg:block">
        <h3 className="text-text text-sm font-semibold mb-2">Opening Hours</h3>
        <ul className="text-sm text-textGray space-y-1">
          {operator.openingHours?.map((dayObj) => (
            <li key={dayObj._id} className="flex justify-between">
              <span>{dayObj.day}</span>
              {dayObj.slots?.length > 0 ? (
                <span>
                  {dayObj.slots.map((slot, idx) => (
                    <span key={slot._id}>
                      {slot.open} - {slot.close}
                      {idx < dayObj.slots.length - 1 ? ", " : ""}
                    </span>
                  ))}
                </span>
              ) : (
                <span className="text-red-400">Closed</span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default OperatorSidebar;
